import he from 'he';

const stepPreviewDefault = {
  isGeneral: true,
  title: 'Título de todos passos',
  kind: 'multiple-choice',
  description_visibility: true,
  description_text: 'Descrição da pergunta',
  options: [
    { label: 'Resposta 1' },
    { label: 'Resposta 2' },
  ],
};

const getJumpsDestinations = steps => {
  const getJumpDestination = jump => jump.destination_step_id;

  return steps
    .filter(step => step.jumps)
    .map(step => step.jumps
      .filter(getJumpDestination)
      .map(getJumpDestination)
    );
};

const reduceStepIds = (steps, step) => {
  if (steps.indexOf(step) < 0) {
    steps.push(step);
  }

  return steps;
};

export const stepList = state => state.list;

export const stepListCount = state => {
  const countableSteps = step => step.kind !== 'redirect' && step.kind !== 'thanks';

  return state.list.filter(countableSteps).length;
};

export const stepListHasJumps = state => {
  const reduceJumps = (jumpList, stepJumps) => {
    jumpList.push(...stepJumps);

    return jumpList;
  };

  return state.list
    .filter(step => step.kind !== 'welcome')
    .map(step => step.jumps)
    .reduce(reduceJumps, [])
    .some(jump => jump.destination_step_id);
};

export const stepActive = state => state.active;

export const stepRedirectEmailService = state => state.active.redirect_email_service;

export const stepDescriptionVisibility = state => state.active.description_visibility;

export const stepCustomizedForm = state => state.active.customized_form;

export const stepFormHtmlDecoded = state => {
  if (!state.active.form_html) {
    return '';
  }

  return he.decode(state.active.form_html);
};

export const stepOriginalFormHtmlDecoded = state => {
  if (!state.active.original_form_html) {
    return '';
  }

  return he.decode(state.active.original_form_html);
};

export const stepTextPlaceholder = state => state.active.placeholder_text;

export const stepInactiveList = state => {
  const active = stepActive(state);
  return state.list.filter(step => step.id !== active.id);
};

export const stepDisplayPosition = () => step => {
  const position = parseInt(step.position, 10) + 1;

  return position || '';
};

export const stepHasOnlyThanks = state => {
  const list = state.list;

  return list.length === 1 && list[0].kind === 'thanks';
};

export const stepIdsUsedInJumps = state => {
  const stepsIds = getJumpsDestinations(state.list);

  return [].concat.apply([], stepsIds).reduce(reduceStepIds, []);
};

export const stepJumpSelectOptions = state => {
  const steps = stepInactiveList(state);
  const stepIds = stepIdsUsedInJumps(state);

  return steps.map(step => {
    const text = `${stepDisplayPosition()(step)} - ${step.title}`;

    return {
      id: step.id,
      text,
      alreadyUsed: stepIds.indexOf(step.id) > -1,
    };
  });
};

export const stepStyle = (state, rootState) => key => {
  if (!state.preview || !state.preview.styles) {
    return rootState.quizStyle(key);
  }

  const style = state.preview.styles[key];
  return style ? style.rules : rootState.quizStyle(key);
};

export const stepPreview = state => (state.preview ? state.preview : stepPreviewDefault);



/** WEBPACK FOOTER **
 ** ./src/store/modules/step/getters.js
 **/